module.exports = __webpack_public_path__ + "img/co2.c6ce84bf.svg";